import { Link, NavLink, Navigate } from "react-router-dom";
import { CalendarDays, Home, Settings, Sun, UserRound } from "lucide-react";
import { useCalAuth } from "@/lib/calAuth";

export function CalProtected({ children }) {
  const { token } = useCalAuth();
  if (!token) return <Navigate to="/calendario/entrar" replace />;
  return children;
}

const TABS = [
  ["/calendario", "Hoy", Sun, "cal-nav-hoy"],
  ["/calendario/mes", "Mes", CalendarDays, "cal-nav-mes"],
  ["/calendario/perfil", "Mi perfil", UserRound, "cal-nav-perfil"],
];

export function CalLayout({ children }) {
  const { person } = useCalAuth();
  const initial = (person?.nickname || person?.name || "?").charAt(0).toUpperCase();
  return (
    <div className="min-h-screen paper-texture iphone-safe-top pb-36">
      <header className="sticky top-0 z-30 bg-paper/90 backdrop-blur-xl border-b border-line">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
          <Link to="/" data-testid="cal-home-hub-btn" aria-label="Volver al inicio" className="p-2 rounded-full bg-cream border border-line hover:border-amber-deep transition-colors">
            <Home className="w-4 h-4 text-cocoa" />
          </Link>
          <div className="text-center min-w-0">
            <p className="eyebrow text-[9px]">Familia Guendelman</p>
            <h1 className="font-display italic text-cocoa text-xl leading-tight truncate">Calendario Familiar</h1>
          </div>
          <div className="flex items-center gap-2">
          {person?.is_admin && (
            <Link to="/calendario/admin" data-testid="cal-admin-btn" aria-label="Admin del calendario" className="p-2 rounded-full bg-cream border border-line hover:border-amber-deep transition-colors">
              <Settings className="w-4 h-4 text-cocoa" />
            </Link>
          )}
          <Link to="/calendario/perfil" data-testid="cal-avatar-btn" aria-label="Mi perfil" className="w-9 h-9 rounded-full bg-night text-candle font-display text-lg flex items-center justify-center">
            {initial}
          </Link>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 pt-6">{children}</main>
      <nav className="fixed bottom-0 inset-x-0 z-40 iphone-safe-bottom">
        <div className="max-w-md mx-auto mb-3 mx-3 sm:mx-auto rounded-full bg-night/95 backdrop-blur-xl shadow-2xl border border-white/10 flex justify-around p-1.5">
          {TABS.map(([to, label, Icon, tid]) => (
            <NavLink key={to} to={to} end data-testid={tid}
              className={({ isActive }) => `flex-1 flex flex-col items-center gap-0.5 rounded-full py-2 text-[11px] font-medium transition-colors ${isActive ? "bg-candle text-night" : "text-white/70 hover:text-white"}`}>
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
